// This file contains the HTML template for emails
// It's stored as a JavaScript string to make it easier to import and use in React

export const emailTemplateHtml = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Professional Email Template</title>
    <style type="text/css">
        /* Reset styles for email clients */
        body, p, h1, h2, h3, h4, h5, h6, table, td {
            margin: 0;
            padding: 0;
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        }
        
        body {
            background-color: #f5f5f5;
            margin: 0;
            padding: 0;
            -webkit-text-size-adjust: 100%;
            -ms-text-size-adjust: 100%;
        }
        
        table {
            border-spacing: 0;
            border-collapse: collapse;
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
        }
        
        img {
            border: 0;
            height: auto;
            line-height: 100%;
            outline: none;
            text-decoration: none;
            -ms-interpolation-mode: bicubic;
        }
        
        /* Main container styles */
        .email-container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
        }
        
        /* Header styles */
        .header {
            background-color: #2D6544;
            color: #ffffff;
            padding: 25px 40px;
        }
        
        .logo-container {
            text-align: center;
            padding: 10px 0;
        }
        
        .logo-placeholder {
            display: inline-block;
            height: 60px;
            width: 200px;
            background-color: rgba(255, 255, 255, 0.2);
            border-radius: 4px;
            line-height: 60px;
            text-align: center;
            font-style: italic;
        }
        
        /* Content styles */
        .content {
            background-color: #ffffff;
            color: #333333;
            padding: 40px;
        }
        
        .section {
            margin-bottom: 30px;
        }
        
        .section-title {
            color: #2D6544;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 15px;
            padding-bottom: 8px;
            border-bottom: 1px solid #eeeeee;
        }
        
        .section-content {
            font-size: 16px;
            line-height: 1.6;
            color: #555555;
        }
        
        /* Feature box */
        .feature-box {
            background-color: #f9f9f9;
            border-left: 4px solid #2D6544;
            padding: 20px;
            margin: 25px 0;
        }
        
        .feature-title {
            color: #2D6544;
            font-weight: 600;
            margin-bottom: 10px;
        }
        
        /* Call to action button */
        .cta-container {
            text-align: center;
            padding: 20px 0;
        }
        
        .cta-button {
            display: inline-block;
            padding: 12px 30px;
            background-color: #2D6544;
            color: #ffffff;
            text-decoration: none;
            font-weight: bold;
            border-radius: 4px;
            font-size: 16px;
        }
        
        /* Footer styles */
        .footer {
            background-color: #2D6544;
            color: #ffffff;
            padding: 20px 40px;
            text-align: center;
            font-size: 14px;
        }
        
        .social-links {
            margin: 15px 0;
        }
        
        .social-link {
            display: inline-block;
            margin: 0 10px;
            color: #ffffff;
            text-decoration: none;
        }
        
        .footer-info {
            opacity: 0.8;
            margin-top: 15px;
            font-size: 12px;
        }
        
        /* Responsive styles */
        @media screen and (max-width: 600px) {
            .header, .content, .footer {
                padding: 20px !important;
            }
            
            .section {
                margin-bottom: 20px !important;
            }
            
            .feature-box {
                padding: 15px !important;
                margin: 15px 0 !important;
            }
        }
    </style>
</head>
<body>
    <center>
        <table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#f5f5f5" style="padding: 20px 0;">
            <tr>
                <td align="center">
                    <!-- Main Email Container -->
                    <table border="0" cellpadding="0" cellspacing="0" width="600" class="email-container">
                        <!-- Header Section with Logo Space -->
                        <tr>
                            <td class="header">
                                <div class="logo-container">
                                    <!-- Company logo -->
                                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHcSURBVHgB7ZnhTcMwEIUviP90hDIBHSFskA3oBnSDdgPEBHQENqBM0G6QMEG7wXFHnokVpVIau+Ua/ElPVtwm8sVn3/lClEgkEonE/yWjyDDzRJpnUS6aifT6AFXQl2iHPmWSZdk7WUeMW4r2XKPtTrRB6/rb6G9TsozOmugDA96Kcsxk+38z0UJUQgu6BmSgLzBu3WXYkXucoUuyDGZLKelE1DXxUuwaiQEqOQ0Ehvaa+YuDNbensTLUPS/FDYWjsazTvcTwYkgIMOWuXnjIW/0F+ud0IqbWpL+L+rOF2JjTQOTeFVlBB+NlJm8UAc2AyBIyoIqbFC3YvfC8KQUSY5NxuJ1UjduGuKdHQYHcUiTkNPCIDUUN3Mn1hsK4Ez3QGMEGFSW+xnTRmORog9eyVQPd2rOZn4aAIP8LjQ0vM/o5PNOY4LrkwbGTBhNwUxXwCY6Dfw7XdZpth3Fmj2C9gGFrPs71uScC+Ly1kXRRcqRSYrRUTcGg9M1/UlPs1Fim/Zp25T0f9SqpXkXWwAztOQzboYHreudQSrZe5Va4PgCXfBrlOYyL/vHFwfWhV+PYDHJUog30JFpRvWYLWXcHGgtwZV2vZ/0+EXUX7Qs3Gcr9qGYtkUgkEgljfAMmNM0rE61VwwAAAABJRU5ErkJggg==" alt="Company Logo" width="60" height="60">
                                </img>
                            </td>
                        </tr>
                        
                        <!-- Main Content Section -->
                        <tr>
                            <td class="content">
                                <!-- Welcome Section -->
                                <div class="section">
                                    <h2 class="section-title">Welcome to Our Newsletter</h2>
                                    <div class="section-content">
                                        <p></p>
                                        <p></p>
                                    </div>
                                </div>
                                
                                
                                <!-- Latest Updates Section -->
                                <div class="section">
                                    <h2 class="section-title">Latest Updates</h2>
                                    <div class="section-content">
                                        <p></p>
                                    </div>
                                </div>
                                
                            </td>
                        </tr>
                        
                        <!-- Footer Section -->
                        <tr>
                            <td class="footer">
                                <p>&copy; 2025 Hema's Enterprises Private Limited. All rights reserved.</p>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </center>
</body>
</html>`;

export default emailTemplateHtml;